import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import { BeatLoader } from "react-spinners";
// import EditQuoteForm from './modal/EditQuoteForm';
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import { adminMainUrl } from "../../../Config";
import { FocusError } from "focus-formik-error";
import Select from "react-select";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { getDriverDetail, getVehicleWithoutList } from "../../../Redux/action/Transport/TransportAction";
import { getLicenseTypeList, getSpecializationList, getVehicleTypeList } from "../../../Redux/action/MasterAction";
const TransportDriverEdit = () => {
    const { b64id } = useParams();
    const token = Cookies.get('token');
    let user_id = Cookies.get('flexichain_user_id');
    const navigate = useNavigate();
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (b64id) {
                let id = atob(b64id);
                if (token && id && user_id) {
                    dispatch(getDriverDetail(token, user_id, id));
                }
            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        }

    }, []);
    const dispatch = useDispatch();
    const {
        loadingDriverDetail,
        DriverDetailDataError,
        DriverDetailData,

        loadingVehicleActiveList,
        VehicleActiveListDataError,
        VehicleActiveListData
    } = useSelector(state => state?.TransportReducer);

    const {
        loadingLicenseTypeActiveApi,
        findLicenseTypeActiveData,
        findLicenseTypeActiveDataError,

        loadingSpecializationActiveApi,
        findSpecializationActiveData,
        findSpecializationActiveDataError,

        loadingVehicleTypeActiveApi,
        findVehicleTypeActiveData,
        findVehicleTypeActiveDataError,

       

    } = useSelector(state => state?.MasterReducer);


    useEffect(() => {
        dispatch(getLicenseTypeList(token, user_id));
        dispatch(getSpecializationList(token, user_id));
        dispatch(getVehicleTypeList(token, user_id));
        dispatch(getVehicleWithoutList(token, user_id));
    }, []);


    const [filePreview, setFilePreview] = useState(null);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Please enter company name"),
        email: Yup.string().required("Please enter email"),
        phone_number: Yup.string().required("Please enter phone number"),
        // emergency_contact_number: Yup.string().required("Please enter primary contact person name"),
        // total_experience: Yup.string().required("Please enter total experience"),
    });

    const GenderOptions = [
        { value: 'Male', label: "Male" },
        { value: 'Female', label: "Female" },
        { value: 'Other', label: "Other" },

    ]

    // const licenseTypeOptions = [
    //     { value: 'Light Vehicle', label: "Light Vehicle" },
    //     { value: 'Heavy Vehicle', label: "Heavy Vehicle" },
    //     { value: 'Commercial', label: "Commercial" },

    // ]

    const currentVehicleStatusOptions = [
        { value: 'Available', label: "Available" },
        { value: ' In Use', label: " In Use" },
        { value: 'Under Maintenance', label: "Under Maintenance" },


    ]

   


    const [licenseTypeOptions,setLicenseTypeOptions] = useState([]);
    useEffect(()=>{
        const formattedOptions = findLicenseTypeActiveData?.map(item => ({
            value: item.name,
            label: item.name
        }));

        setLicenseTypeOptions(formattedOptions)
    },[findLicenseTypeActiveData])


    const [specializationOptions,setSpecializationOptions] = useState([]);
    useEffect(()=>{
        const formattedOptions = findSpecializationActiveData?.map(item => ({
            value: item.name,
            label: item.name
        }));

        setSpecializationOptions(formattedOptions)
    },[findSpecializationActiveData])

    const [vehicleTypeOptions,setVehicleTypeOptions] = useState([]);
    useEffect(()=>{
        const formattedOptions = findVehicleTypeActiveData?.map(item => ({
            value: item.name,
            label: item.name
        }));

        setVehicleTypeOptions(formattedOptions)
    },[findVehicleTypeActiveData])


    const [assignedVehicleOptions,setAssignedVehicleOptions] = useState([]);
    useEffect(()=>{
        const formattedOptions = VehicleActiveListData?.map(item => ({
            value: item.vehicle_id,
            label: item.vehicle_id
        }));

        setAssignedVehicleOptions(formattedOptions)
    },[VehicleActiveListData])

    // const vehicleTypeOptions = [
    //     { value: 'Truck', label: "Truck" },
    //     { value: 'Van', label: "Van" },
    //     { value: 'Trailer', label: "Trailer" },
    //     { value: 'Other', label: "Other" },
    // ]

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };

   


    const formik = useFormik({
        initialValues: {
            name: "",
            dob: "",
            gender: "",
            phone_number: "",
            email: "",
            residential_address: "",
            emergency_contact_number: "",
            license_number: "",
            license_expiry_date: "",
            issuing_authority: "",
            region_license_issue: "",
            total_experience: "",
            license_type: "",
            specialization: "",
            previous_employers: "",
            assigned_vehicle: "",
            vehicle_type: "",
            vehicle_license_plate: "",
            maintenance_due_date: "",
            current_vehicle_status: "",
            profile_pic: "",



        },
        validationSchema,
        onSubmit: (values, { resetForm }) => {


            setDisableSubmitBtn(true);
            try {
                let config = { headers: { 'auth-token': Cookies.get('token'), 'user_id': user_id, 'Content-Type': 'multipart/form-data' } }
                const formData = new FormData();
                formData.append("name", values.name);
                formData.append("gender", values.gender);
                formData.append("license_number", values.license_number);
                formData.append("issuing_authority", values.issuing_authority);
                formData.append("region_license_issue", values.region_license_issue);
                formData.append("emergency_contact_number", values.emergency_contact_number);
                formData.append("total_experience", values.total_experience);
                formData.append("phone_number", values.phone_number);
                formData.append("email", values.email);
                formData.append("residential_address", values.residential_address);
                formData.append("license_type", values.license_type);
                formData.append("specialization", values.specialization);
                formData.append("license_expiry_date", values.license_expiry_date);
                formData.append("previous_employers", values.previous_employers);
                formData.append("assigned_vehicle", values.assigned_vehicle);
                formData.append("vehicle_type", values.vehicle_type);
                formData.append("vehicle_license_plate", values.vehicle_license_plate);
                formData.append("profile_pic", values.profile_pic);
                formData.append("maintenance_due_date", values.maintenance_due_date);
                formData.append("current_vehicle_status", values.current_vehicle_status);
                formData.append("dob", values.dob);

                axios.post(`${adminMainUrl}/api/transport/driver/update?id=${DriverDetailData?.id}`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            setDisableSubmitBtn(false);
                            toast.success(response?.data?.msg);

                            dispatch(getDriverDetail(token, user_id, DriverDetailData?.id));
                            // navigate('/flexichain/transport-driver-list')
                        } else {
                            setDisableSubmitBtn(false);
                            toast.error(response?.data?.msg)
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        setDisableSubmitBtn(false);
                        let msg = "";
                        if (err.response) {
                            msg = err.response.data.msg;
                        } else {
                            msg = "Internal Server Error!"
                        };
                        toast.error(msg);
                    })
            } catch (error) {
                setDisableSubmitBtn(false);
                console.log(error);
                toast.error("Internal Server Error!")
            }
        }
    });
   
    useEffect(() => {
        if (DriverDetailData) {

            formik.setValues({
                name: DriverDetailData?.name ?? "",
                gender: DriverDetailData?.gender ?? "",
                license_number: DriverDetailData?.license_number ?? "",
                issuing_authority: DriverDetailData?.issuing_authority ?? "",
                region_license_issue: DriverDetailData?.region_license_issue ?? "",
                emergency_contact_number: DriverDetailData?.emergency_contact_number ?? "",
                total_experience: DriverDetailData?.total_experience ?? "",
                phone_number: DriverDetailData?.phone_number ?? "",
                email: DriverDetailData.email ?? "",
                residential_address: DriverDetailData.residential_address ?? "",
                license_type: DriverDetailData.license_type ?? "",
                specialization: DriverDetailData.specialization ?? "",
                license_expiry_date: DriverDetailData.license_expiry_date ?? "",
                previous_employers: DriverDetailData.previous_employers ?? "",

                assigned_vehicle: DriverDetailData?.assigned_vehicle ?? "",
                vehicle_type: DriverDetailData?.vehicle_type ?? "",
                vehicle_license_plate: DriverDetailData?.vehicle_license_plate ?? "",
                profile_pic: DriverDetailData?.profile_pic ?? "",
                maintenance_due_date: DriverDetailData?.maintenance_due_date ?? "",
                current_vehicle_status: DriverDetailData?.current_vehicle_status ?? "",

                dob: DriverDetailData?.dob ?? "",
              

            })
            setFilePreview(`${adminMainUrl}/${DriverDetailData?.profile_pic}`)
        }
    }, [DriverDetailData])
    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            formik.setFieldValue('profile_pic', file); // Update formik field value
            setFilePreview(URL.createObjectURL(file)); // Set the preview URL
        }
    };


    return (
        <>
            <div className="page-wrapper">
                <form onSubmit={formik.handleSubmit}>
                    <FocusError formik={formik} />
                    <div className="content">
                        <div className="row">
                            <div className="col-md-12">
                                {/* Page Header */}
                                <div className="page-header">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h4 className="page-title">Driver Form</h4>
                                        </div>
                                    </div>
                                </div>
                                {/* /Page Header */}
                            </div>
                        </div>
                        <div className="card">

                            <div className="card-body">


                                <div className="main_detail_form mt-2">
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Driver information</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Name <span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Name"
                                                    value={formik?.values?.name}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    // onKeyPress={(event) => {
                                                    //     const inputValue = event.target.value;
                                                    //     if (
                                                    //         inputValue.length == 0 &&
                                                    //         event.key == " "
                                                    //     ) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}
                                                />
                                                {formik?.touched.name &&
                                                    formik?.errors.name ? (
                                                    <div className="error">
                                                        {formik?.errors.name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Date Of Birth 
                                                </label>
                                                <div
                                                    className="custom-datepicker"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        name="dob"
                                                        min={new Date().toISOString().split("T")[0]}
                                                        value={formik.values.dob || ""}
                                                        onChange={(e) => {
                                                            formik.setFieldValue(
                                                                "dob",
                                                                e.target.value
                                                            );
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.dob &&
                                                        formik.errors.dob ? (
                                                        <div className="error">
                                                            {formik.errors.dob}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Gender Type
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={GenderOptions}
                                                    name="gender"
                                                    value={GenderOptions.find(option => option.value == formik.values.gender)}
                                                    onChange={option => formik.setFieldValue('gender', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.gender && formik.errors.gender ? (
                                                    <div className="error">{formik.errors.gender}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Phone Number <span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Phone Number"
                                                    name="phone_number"
                                                    value={formik?.values?.phone_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    // onKeyPress={(event) => {
                                                    //     if (!/\d/.test(event.key)) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}
                                                    maxLength={10}
                                                />
                                                {formik?.touched?.phone_number && formik?.errors?.phone_number ? (
                                                    <div className="error">{formik?.errors?.phone_number}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Email Id <span>*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Email"
                                                    name="email"
                                                    value={formik?.values.email}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                />
                                                {formik?.touched.email && formik?.errors?.email ? (
                                                    <div className="error">{formik?.errors?.email}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Residential Address
                                                </label>
                                                <input
                                                    type="text"
                                                    name="residential_address"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Residential Address"
                                                    value={formik?.values?.residential_address}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    // onKeyPress={(event) => {
                                                    //     const inputValue = event.target.value;
                                                    //     if (
                                                    //         inputValue.length == 0 &&
                                                    //         event.key == " "
                                                    //     ) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}
                                                />
                                                {formik?.touched.residential_address &&
                                                    formik?.errors.residential_address ? (
                                                    <div className="error">
                                                        {formik?.errors.residential_address}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Emergency Contact Number 
                                                </label>
                                                <input
                                                    type="text"
                                                    name="emergency_contact_number"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Emergency Contact Number"
                                                    value={formik?.values?.emergency_contact_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    // onKeyPress={(event) => {
                                                    //     if (!/\d/.test(event.key)) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}
                                                    maxLength={10}
                                                />
                                                {formik?.touched.emergency_contact_number &&
                                                    formik?.errors.emergency_contact_number ? (
                                                    <div className="error">
                                                        {formik?.errors.emergency_contact_number}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>


                                    </div>
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">License Details</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    License Number
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter License Number"
                                                    name="license_number"
                                                    value={formik?.values?.license_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="\d*"
                                                    // onKeyPress={(event) => {
                                                    //     const inputValue = event.target.value;
                                                    //     if (
                                                    //         inputValue.length == 0 &&
                                                    //         event.key == " "
                                                    //     ) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}
                                                />
                                                {formik?.touched?.license_number && formik?.errors?.license_number ? (
                                                    <div className="error">{formik?.errors?.license_number}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    License Type
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={licenseTypeOptions}
                                                    name="license_type"
                                                    value={licenseTypeOptions.find(option => option.value == formik.values.license_type)}
                                                    onChange={option => formik.setFieldValue('license_type', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.license_type && formik.errors.license_type ? (
                                                    <div className="error">{formik.errors.license_type}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    License Expiry Date 
                                                </label>
                                                <div
                                                    className="custom-datepicker"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        name="license_expiry_date"
                                                        min={new Date().toISOString().split("T")[0]}
                                                        value={formik.values.license_expiry_date || ""}
                                                        onChange={(e) => {
                                                            formik.setFieldValue(
                                                                "license_expiry_date",
                                                                e.target.value
                                                            );
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.license_expiry_date &&
                                                        formik.errors.license_expiry_date ? (
                                                        <div className="error">
                                                            {formik.errors.license_expiry_date}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Issuing Authority
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Issuing Authority"
                                                    name="issuing_authority"
                                                    value={formik?.values?.issuing_authority}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    // onKeyPress={(event) => {
                                                    //     const inputValue = event.target.value;
                                                    //     if (
                                                    //         inputValue.length == 0 &&
                                                    //         event.key == " "
                                                    //     ) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}
                                                />
                                                {formik?.touched?.issuing_authority && formik?.errors?.issuing_authority ? (
                                                    <div className="error">{formik?.errors?.issuing_authority}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Country/Region of Issue
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Country/Region of Issue"
                                                    name="region_license_issue"
                                                    value={formik?.values?.region_license_issue}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    // onKeyPress={(event) => {
                                                    //     const inputValue = event.target.value;
                                                    //     if (
                                                    //         inputValue.length == 0 &&
                                                    //         event.key == " "
                                                    //     ) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}

                                                />
                                                {formik?.touched?.region_license_issue && formik?.errors?.region_license_issue ? (
                                                    <div className="error">{formik?.errors?.region_license_issue}</div>
                                                ) : null}
                                            </div>
                                        </div>




                                    </div>
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Experience</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Total Experience 
                                                </label>
                                                <input
                                                    type="text"
                                                    name="total_experience"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Total Experience"
                                                    value={formik?.values?.total_experience}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    // onKeyPress={(event) => {
                                                    //     if (!/\d/.test(event.key)) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}
                                                    maxLength={30}
                                                />
                                                {formik?.touched.total_experience &&
                                                    formik?.errors.total_experience ? (
                                                    <div className="error">
                                                        {formik?.errors.total_experience}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Specialization
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={specializationOptions}
                                                    name="specialization"
                                                    value={specializationOptions.find(option => option.value == formik.values.specialization)}
                                                    onChange={option => formik.setFieldValue('specialization', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.specialization && formik.errors.specialization ? (
                                                    <div className="error">{formik.errors.specialization}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Previous Employer(s)
                                                </label>
                                                <textarea


                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Previous Employer(s)"
                                                    name="previous_employers"
                                                    value={formik?.values.previous_employers}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                />

                                                {formik.touched.previous_employers && formik.errors.previous_employers ? (
                                                    <div className="error">{formik.errors.previous_employers}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Vehicle Assignments</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Assigned Vehicle Options
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={assignedVehicleOptions}
                                                    name="assigned_vehicle"
                                                    value={assignedVehicleOptions.find(option => option.value == formik.values.assigned_vehicle)}
                                                    onChange={option => formik.setFieldValue('assigned_vehicle', option.value)}
                                                    onBlur={formik.handleBlur}
                                                    isMulti
                                                />

                                                {formik.touched.assigned_vehicle && formik.errors.assigned_vehicle ? (
                                                    <div className="error">{formik.errors.assigned_vehicle}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Vehicle Type
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={vehicleTypeOptions}
                                                    name="vehicle_type"
                                                    value={vehicleTypeOptions.find(option => option.value == formik.values.vehicle_type)}
                                                    onChange={option => formik.setFieldValue('vehicle_type', option.value)}
                                                    onBlur={formik.handleBlur}

                                                />

                                                {formik.touched.vehicle_type && formik.errors.vehicle_type ? (
                                                    <div className="error">{formik.errors.vehicle_type}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Vehicle License Plate
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Vehicle License Plate"
                                                    name="vehicle_license_plate"
                                                    value={formik?.values?.vehicle_license_plate}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    // onKeyPress={(event) => {
                                                    //     const inputValue = event.target.value;
                                                    //     if (
                                                    //         inputValue.length == 0 &&
                                                    //         event.key == " "
                                                    //     ) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}

                                                />
                                                {formik?.touched?.vehicle_license_plate && formik?.errors?.vehicle_license_plate ? (
                                                    <div className="error">{formik?.errors?.vehicle_license_plate}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Maintenance Due Date for Vehicle 
                                                </label>
                                                <div
                                                    className="custom-datepicker"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        name="maintenance_due_date"
                                                        min={new Date().toISOString().split("T")[0]}
                                                        value={formik.values.maintenance_due_date || ""}
                                                        onChange={(e) => {
                                                            formik.setFieldValue(
                                                                "maintenance_due_date",
                                                                e.target.value
                                                            );
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.maintenance_due_date &&
                                                        formik.errors.maintenance_due_date ? (
                                                        <div className="error">
                                                            {formik.errors.maintenance_due_date}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Current Vehicle Status
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={currentVehicleStatusOptions}
                                                    name="current_vehicle_status"
                                                    value={currentVehicleStatusOptions.find(option => option.value == formik.values.current_vehicle_status)}
                                                    onChange={option => formik.setFieldValue('current_vehicle_status', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.current_vehicle_status && formik.errors.current_vehicle_status ? (
                                                    <div className="error">{formik.errors.current_vehicle_status}</div>
                                                ) : null}
                                            </div>
                                        </div>






                                    </div>


                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Profile Photo</h4>
                                    </div>
                                    <div className="row">


                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label htmlFor="profile_pic" className="form-label">
                                                    Profile Photo
                                                </label>
                                                <input
                                                    type="file"
                                                    name="profile_pic"
                                                    className="form-control form-control-sm"
                                                    onChange={(e) => { handleFileChange(e) }}
                                                />
                                                {formik.touched.profile_pic && formik.errors.profile_pic ? (
                                                    <div className="error">{formik.errors.profile_pic}</div>
                                                ) : null}
                                            </div>
                                            {filePreview && (
                                                <div className="image-preview mt-2">
                                                    <img src={filePreview} alt="Preview" className="img-thumbnail" style={{ width: '200px', height: 'auto' }} />
                                                </div>
                                            )}
                                        </div>


                                    </div>


                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <button
                                            className="btn btn-main-form me-md-2"
                                            type="submit"
                                            disabled={disableSubmitBtn}
                                        >
                                            {disableSubmitBtn ? <><i className="fas fa-spinner fa-spin"></i> Saving</> : "Create Driver"}
                                        </button>
                                    </div>
                                </div>





                            </div>
                        </div>
                    </div>
                </form >
            </div >
        </>
    )
}

export default TransportDriverEdit